import firebaseUtil from './firebaseUtil'
import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash'

import { useNavigate } from 'react-router-dom';
import { crateSnapDocument, salvarPerfilLogin, salvarPerfilRegistro } from './dbApi';

import { getAuth, sendPasswordResetEmail } from "firebase/auth"
import useNotification from 'notification';

export function useUserUid() {
    if (!firebaseUtil.getCurrentUser()) {
        return null;
    }
    return firebaseUtil.getCurrentUser().uid
}
export const getUserSnap = (uidUser, resolve, reject) => {
    let colCustomForm = 'PerfilUser';
    return crateSnapDocument(uidUser, colCustomForm,
        (r) => {
            resolve(r)
        },
        (err) => {
            console.log('getUserSnap erro', err)
            reject(err)
        }
    )
}

export const usePerfil = () => {
    const [perfil, setPerfil] = useState(null);
    const useruid = useUserUid();

    useEffect(() => {
        let observer
        if (useruid) {
            observer = getUserSnap(useruid,
                (r) => {
                    setPerfil((old) => {
                        if (!_.isEqual({ ...old, lastChange: null, lastLogin: null }, { ...r, lastChange: null, lastLogin: null })) {
                            return r
                        }
                        return old
                    })
                    // setPerfil(r)
                },
                (err) => {
                    setPerfil(null)
                }
            );
        } else {
            setPerfil(undefined)
        }
        return () => {
            if (observer) {
                observer();
            }
        }

    }, [useruid])

    return perfil;

}


export function useIsAdmin() {
    let perfil = usePerfil();

    let isAdmin = false;

    if (perfil) {
        if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
            isAdmin = true;
        }
    }

    return isAdmin;
}
export function useNotAuthenticatedOnly() {
    const { redirectPosAuth } = useAuth()
    useEffect(() => {
        if (firebaseUtil.getCurrentUser()) {
            redirectPosAuth()
        }
    }, [redirectPosAuth])
    return null;
}

export function useAuthenticatedOnly() {
    const { redirectLogin } = useAuth()
    useEffect(() => {
        if (!firebaseUtil.getCurrentUser()) {
            redirectLogin()
        }
    }, [redirectLogin])
    return null;
}

export async function useActiveUsersOnly() {
    const user = usePerfil()
    const { redirectLogin } = useAuth()
    const { showWarning } = useNotification();

    if (user && (user.status === "INATIVO" || user.status === "DELETAR")) {
        await firebaseUtil.logout()
        redirectLogin()
        showWarning("Não permitido! Usuário inativo no sistema. Entre em contato com o responsável")
    }
}

export default function useAuth() {
    const navigate = useNavigate();
    const currentUser = firebaseUtil.getCurrentUser();
    const redirectPosAuth = (pagePosLogin) => {
        navigate('/')
    }
    const redirectLogin = () => {
        navigate('/Login')
    }
    const redirectRegister = () => {
        navigate('/Register')
    }

    const isAuthenticated = useCallback(() => {
        if (!currentUser) {
            return false;
        } else {
            return true;
        }
    }, [currentUser])


    const userName = () => {
        return firebaseUtil.getCurrentUsername()
    }
    const userUid = () => {
        if (!firebaseUtil.getCurrentUser()) {
            return null
        }
        return firebaseUtil.getCurrentUser().uid
    }

    const user = () => {
        return firebaseUtil.getCurrentUser()
    }

    const registerLogin = () => {
        // console.log('registerLogin', firebase.getCurrentUser())
        if (firebaseUtil.getCurrentUser()) {
            salvarPerfilLogin(firebaseUtil.getCurrentUser());
        }
    }
    const registerSingIn = () => {
        // console.log('registerSingIn', firebase.getCurrentUser())
        if (firebaseUtil.getCurrentUser()) {
            salvarPerfilRegistro(firebaseUtil.getCurrentUser());
        }
    }


    return { redirectLogin, redirectRegister, redirectPosAuth, userName, userUid, user, registerLogin, registerSingIn, isAuthenticated }
}

export function useInDebug() {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (inDebug) {
        return true
    } else {
        return false
    }
}

export async function triggerResetEmail(email) {
    let auth = getAuth()
    await sendPasswordResetEmail(auth, email)
    // console.log(email)
    console.log("Password reset email sent")
}